module.exports = __webpack_public_path__ + "img/bandaidsX.65dd8d8c.jpg";